




import { Component, Vue } from "vue-property-decorator";

/**
 * Utils
 */

/**
 * Components
 */

/**
 * API
 */

/**
 * Types
 */


/**
 * VueX Modules
 */

/**
 * Admin layout.
 */
@Component
export default class AdminLayout extends Vue {
}
